import React from 'react';
import PublicPageLayout from '../components/marketing/PublicPageLayout';
import Wellcome from '../components/Wellcome';

const GetStarted = () => (
  <PublicPageLayout>
    <Wellcome />
  </PublicPageLayout>
);

export default GetStarted;
